module.exports = "/_next/static/images/img__bottom__left__desktop-bdca80edd1b110f1dc6938761501a553.png";